import FirestoreType from './FirestoreType'

export default class User extends FirestoreType {
    get name() { return this.data.name; }
    get email() { return this.data.email; }
    get isAdmin() { return this.data.isAdmin; }
}